import { render, staticRenderFns } from "./SiteCreate.vue?vue&type=template&id=3bf219af&"
import script from "./SiteCreate.vue?vue&type=script&lang=ts&"
export * from "./SiteCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports